import api from './api';

const billingApi = {
  getPlans: () => api.get('/billing/plans'),
  getSubscription: (businessId) => api.get('/billing/subscription', { params: { business_id: businessId } }),
  subscribe: (data) => api.post('/billing/subscribe', data),
  completeCheckout: (data) => api.post('/billing/checkout/complete', data),
  changePlan: (data) => api.post('/billing/change-plan', data),
  cancel: (data) => api.post('/billing/cancel', data),
  resume: (data) => api.post('/billing/resume', data),
  openPortal: (data) => api.post('/billing/portal', data),
};

// Sends the browser to Stripe Checkout for a plan, or reports what happened
// when no checkout opens (local placeholder billing activates in place).
export async function startPlanCheckout({ businessId, plan, billingCycle }) {
  const res = await billingApi.subscribe({ business_id: businessId, plan, billing_cycle: billingCycle });
  if (res.data.checkoutOpen && res.data.checkoutAddress) {
    window.location.assign(res.data.checkoutAddress);
    return { redirected: true };
  }
  return { redirected: false, status: res.data.status };
}

export default billingApi;
